// import 'quill-mention';
import 'easymde/dist/easymde.min.css';
import { Dispatch, SetStateAction, useMemo } from 'react';
import SimpleMDEditor from 'react-simplemde-editor';
import './style.scss';

export default function Editor({
  value,
  setValue,
}: {
  value: string;
  setValue: Dispatch<SetStateAction<string>>;
}) {
  const autofocusNoSpellcheckerOptions = useMemo(() => {
    return {
      autofocus: true,
      scrollbarStyle: 'native',
      toolbar: [
        'bold',
        'italic',
        'strikethrough',
        '|',
        'heading-smaller',
        'heading-bigger',
        'ordered-list',
        'unordered-list',
        '|',
        'quote',
        'code',
        'undo',
      ],
    } as any;
  }, []);

  return (
    <SimpleMDEditor
      placeholder="Type here..."
      options={autofocusNoSpellcheckerOptions}
      value={value}
      onChange={setValue}
      className="bg-secondary-700"
      textareaProps={{}}
    />
  );
}
